/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {
    Directive,
    ElementRef,
    HostListener, Renderer2
} from '@angular/core';

@Directive({
    selector: 'input[decimalNumbersOnly]',
    standalone: false
})
export class DecimalNumbersOnlyDirective {
    constructor(private elementRef: ElementRef,  private renderer: Renderer2) {
    }

    @HostListener('input', ['$event'])
    onInputChange = (event: Event): void => {
        const initialValue = this.elementRef.nativeElement.value;
        this.elementRef.nativeElement.value = initialValue
                .replace(/[^\d.]/g, '');
        this.renderer.setAttribute(this.elementRef.nativeElement, 'initial-value', initialValue);
        if (initialValue !== this.elementRef.nativeElement.value) {
            event.stopPropagation();
        }
    };
}
